export default "__VITE_ASSET__F6X2xTtw__"